import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getRequest, deleteRequest } from 'utils/http'

const SUBSCRIBER_QUERY_KEY = 'subscribers'

export const getSubscribers = async (current, pageSize) => {
  return getRequest('subscribers', {
    params: {
      page: current,
      pageSize: pageSize,
    },
  })
}

export const useGetSubscribers = (current, pageSize) => {
  return useQuery({
    queryKey: [SUBSCRIBER_QUERY_KEY, current, pageSize],
    queryFn: () => getSubscribers(current, pageSize),
  })
}

export const deleteSubscriber = async id => {
  return deleteRequest(`subscribers/${id}`)
}

export const useDeleteSubscriber = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteSubscriber,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [SUBSCRIBER_QUERY_KEY] })
    },
    onError: error => {
      console.error('Failed to delete subscriber:', error)
      // Implement a toast notification here
    },
  })
}
